import palette from './palette';

export const dropdownOptionStyles = {
  padding: '5px 10px',
  '&[aria-selected="true"], &:hover': {
    backgroundColor: `${palette.grey[200]} !important`,
  },
};

const menu = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        ...dropdownOptionStyles,
      },
    },
  },
};

export default menu;
